import Button from "@mui/material/Button";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import {useState} from "react";

const Collapsable = (props) => {
    Collapsable.defaultProps = {
        openInitial: false,
    }
    const [open, setOpen] = useState(props.openInitial);

    return (
        <div className="my-2">
            <Button size="large" onClick={() => setOpen(!open)}
                    startIcon={open ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>}
                    color="textColor">{props.title}</Button>
            {open && <div className=" p-4 bg-neutral-300 dark:bg-neutral-800 border-neutral-700 border-2 dark:border-neutral-900 rounded">
                {props.children}
            </div>}

        </div>
    );
}

export default Collapsable;